import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import ASSETS from '../../../assets';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Link, useNavigate } from 'react-router-dom';

dayjs.extend(utc);
dayjs.extend(relativeTime);

const Block = ({ data }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/block/${data?.block_number}`);
  };
  return (
    <div
      className='py-[14px] px-4 flex items-center gap-20 hover:bg-hover cursor-pointer border-b border-b-bryt-grey-200 last-of-type:border-b-0'
      onClick={handleClick}
    >
      <div className='flex items-center gap-2'>
        <div className='h-12 w-12 rounded-lg grid place-items-center bg-bryt-grey-100'>
          <img src={ASSETS.block} alt='' />
        </div>
        <div>
          <p className='text-[14.5px] text-bryt-primary-main min-w-[16ch]'>
            {data?.block_number}
          </p>
          <p className='text-[14.5px] text-bryt-grey-700'>
            {dayjs.unix(data?.timestamp).fromNow()}
          </p>
        </div>
      </div>
      <div className='flex-grow flex items-center justify-between gap-2'>
        <div>
          <p className='text-[14.5px]'>
            Fee Recipient{' '}
            <span className='text-bryt-primary-main'>Titan Builder</span>
          </p>
          <p className='text-[14.5px]'>
            <span className='text-bryt-primary-main'>
              {data?.transactions?.length || 0} txns{' '}
            </span>
            <span className='text-[12.5px] text-bryt-grey-700'></span>
          </p>
        </div>
        <div className='min-w-[84px] px-[9px] py-[7px] border border-bryt-grey-300 rounded-[6px]'>
          <p className='text-[11px] font-semibold'>0 RYT</p>
        </div>
      </div>
    </div>
  );
};

const Blocks = () => {
  const { blocks } = useSelector(state => state.blocks);

  const [list, setList] = useState([]);

  useEffect(() => {
    if (blocks.length > 7) {
      setList(blocks.slice(0, 7));
    } else {
      setList(blocks);
    }
  }, [blocks]);

  return (
    <div className='border border-bryt-grey-200 rounded-[12px] flex flex-col overflow-hidden'>
      <div className='bg-bryt-primary-main p-4 flex items-center justify-between'>
        <p className='text-[15px] font-semibold text-white'>Latest Blocks</p>
        <button className='flex items-center gap-1 px-2 py-[5px] bg-white border border-bryt-grey-200 rounded-[6px] cursor-not-allowed'>
          <img src={ASSETS.sortBy} alt='' />
          <p className='text-xs text-bryt-primary-main'>Sort by</p>
        </button>
      </div>
      <div>
        {list?.map(block => (
          <Block key={block?.unix_timestamp} data={block} />
        ))}
      </div>
      <div className='flex items-center justify-center gap-[10px] p-6 border-t border-t-bryt-grey-200 cursor-pointer'>
        <Link to='/blocks'>
          <p className='text-xs font-semibold text-bryt-grey-700 uppercase'>
            View all blocks
          </p>
        </Link>
        <img src={ASSETS.arrowRight} alt='' />
      </div>
    </div>
  );
};

export default Blocks;
